import React from 'react'
import FrontendLayout from '../FrontendLayout'
import Banner from '../front-components/Banner'
import About from '../front-components/About'
import Services from '../front-components/Services'
import Feature from '../front-components/Feature'
import Trucks from '../front-components/Trucks'

export default function Home() {
  return (
    <FrontendLayout>        
        <Banner />
        <About /> 
        <Feature />
        <Services />
        <Trucks />
    </FrontendLayout>
  )
}
